import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

const Header = ({ openModalToggle }) => {
  const [mainMenuOpen, setmainMenuOpen] = useState(false);

  const mainMenuOpenToggle = useCallback(() => {
    setmainMenuOpen((state) => !state);
  }, []);

  const mainMenuClose = useCallback(() => {
    setmainMenuOpen(() => false);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mainMenuOpen ? 'hidden' : 'visible';
  }, [mainMenuOpen]);

  // useEffect(() => {
  //   // e.preventDefault();
  //   // e.stopPropagation();

  //   //const target = e.target.closest('a');
  //   const { hash } = window.location;
  //   mainMenuClose();

  //   if (hash) {
  //     window.scrollTo({
  //       top: document.querySelector(hash).offsetTop - 100,
  //       behavior: 'smooth',
  //     });
  //   }
  // }, []);

  return (
    <nav className="header">
      <div className="container  ">
        <div
          className={`nav-block flex-row col ${
            mainMenuOpen ? 'hamburger-cross' : ''
          }`}>
          <Link to="/" onClick={mainMenuClose} className="cliphire-logo">
            <img src="/img/cliphire-recruit-logo.svg" alt="" />
          </Link>
          <div
            className={`menu flex-row no-margin ${
              mainMenuOpen ? 'menu-open' : ''
            }`}>
            <div className="left-nav flex-row align-items-center">
              <div>
                <AnchorLink
                  to="/#feature"
                  title="Features"
                  onAnchorLinkClick={mainMenuClose}
                />
              </div>
              <div>
                <AnchorLink
                  to="/#pricing"
                  title="Pricing"
                  onAnchorLinkClick={mainMenuClose}
                />
              </div>
            </div>
            <div className="right-nav">
              <button
                type="button"
                className="sign-up button button-green "
                onClick={openModalToggle}>
                Join Waitlist
              </button>
            </div>
          </div>
          <button
            type="button"
            onClick={mainMenuOpenToggle}
            className="visible-tablet hamburger">
            <span />
          </button>
        </div>
      </div>
    </nav>
  );
};

Header.propTypes = {
  openModalToggle: PropTypes.func.isRequired,
};

export default Header;
